import store from '~/store'

const appendDefaultParamsToRoute = (route) => {
  const r = route
  const mergedParams = {
    instance: store.getters['instancesState/getInstanceUrlParam'],
    event: store.getters['instancesState/getEvent'],
    language: store.getters['instancesState/getLanguage'],
  }
  Object.assign(mergedParams, r.params)
  r.params = mergedParams
  return r
}

export default appendDefaultParamsToRoute
